module.exports = __webpack_public_path__ + "static/media/asingh_CV.65a67be6.pdf";